import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import moment from 'moment';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';

export class DueDate extends Field {
  static attributesForModel() {
    return ['dueDate'];
  }

  get title() {
    return 'Due date';
  }

  get icon() {
    if (this.modelClass.typename === 'Task') {
      return 'fa-regular fa-calendar-lines';
    }

    return 'fa-regular fa-hourglass-end';
  }

  exampleContents(): FieldContentsData {
    return {
      text: dateFormattedWithUserLocale(moment().add(3, 'months')),
      icon: { name: this.icon },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.dueDate) {
      return {
        text: dateFormattedWithUserLocale(record.dueDate),
        icon: { name: this.icon },
      };
    }

    return {};
  }
}
